import React, { useEffect, useState } from 'react';
import { Button, Tab, Tabs } from '@material-ui/core';
import { Add } from '@material-ui/icons';
import ImagePicker from '../../../../shared/ui-builder/image-picker/Image-Picker';
import CustomUiBuilderTextField from '../../../../shared/form-controls/custom-ui-builder-text-field/Custom-UI-Builder-Text-Field';
import { ACCORDION_W_ICON } from '../../../../constants/UiBuilderConst';
import TextField from '@mui/material/TextField';
import { InputAdornment } from '@mui/material';
import { handleRemoveClick } from '../../../../utils/UiBuilderUtils';

const AccordionWithIcon = (props) => {
  const { onItemChange, config, groupId, handleError, componentNdx } = props;
  const initialSlide = {
    imgURL: null,
    titleH3: '',
    body: '',
  };
  const [slidesList, setSlidesList] = useState(
    config?.accordions && config?.accordions?.length ? config.accordions : [initialSlide],
  );
  const [activeTabIndex, setActveTabIndex] = useState(0);
  const [activeTabContent, setActveTabContent] = useState(
    config?.accordions && config?.accordions.length ? config.accordions[0] : initialSlide,
  );
  const [error, setError] = useState(null);

  useEffect(() => {
    onItemChange({
      componentName: ACCORDION_W_ICON,
      config: {
        accordions: slidesList,
      },
    });
  }, [slidesList]);

  useEffect(() => {
    if (handleError && handleError.length > 0) {
      const currError = handleError.find(
        (getError) => getError.pos === componentNdx && getError.id === ACCORDION_W_ICON,
      );
      if (currError && currError.accordions.length > 0) {
        const sliderNdx = Math.min.apply(
          Math,
          currError.accordions.map((o) => o.pos),
        );
        setActveTabIndex(sliderNdx);
        setActveTabContent(slidesList[sliderNdx]);
      }
      setError(currError ?? null);
    }
  }, [handleError]);

  const onTabAdd = () => {
    if (slidesList.length < 8) {
      const tempList = [...slidesList];
      tempList.push(initialSlide);
      setActveTabContent(initialSlide);
      setSlidesList(tempList);
      setActveTabIndex(tempList.length - 1);
    }
  };

  const setErrorField = (field, val) => {
    if (field !== 'redirect') {
      const trimmed = typeof val === 'string' ? val?.trim() : val;
      return trimmed ? '' : 'required';
    } else {
      if (val?.type && val?.value) return '';
      return 'required';
    }
  };

  const handleTabData = (rawVal, slideContent, field) => {
    const value = rawVal;
    const trimmed = typeof rawVal === 'string' ? rawVal?.trim() : rawVal;
    if (['titleH3', 'body'].includes(field)) {
      let currError = error;
      if (!currError) {
        currError = {
          pos: componentNdx,
          id: ACCORDION_W_ICON,
          accordions: slidesList?.map((_, idx) => ({ pos: idx })),
        };
      }
      currError = {
        ...currError,
        accordions: currError?.accordions?.map((errObj) =>
          errObj?.pos === activeTabIndex
            ? { ...errObj, [field]: setErrorField(field, trimmed) }
            : errObj,
        ),
      };
      setError(currError);
    }
    switch (field) {
      case 'titleH3':
        slideContent.titleH3 = value;
        break;
      case 'body':
        slideContent.body = value;
        break;
      case 'imgURL':
        slideContent.imgURL = value;
        if (error?.accordions?.length) {
          const cleared = error?.accordions?.map((e) =>
            e?.pos === activeTabIndex ? { ...e, imgURL: '' } : e,
          );
          setError({ ...error, accordions: cleared });
        }
        break;
    }

    setSlidesList(slidesList?.map((s, i) => (i === activeTabIndex ? { ...slideContent } : s)));
  };

  const onTabChange = (e, value) => {
    setActveTabIndex(value);
    setActveTabContent(slidesList[value]);
  };

  const hasError = (key) => {
    const hasSliderError = error?.accordions?.find(
      (errorSlider) => errorSlider.pos === activeTabIndex && errorSlider[key] === 'required',
    );
    if (hasSliderError) return true;
    return false;
  };

  return (
    <div className='row my-2 mx-4'>
      <div className='col-md-10'>
        <div className='row mt-4 mb-3'>
          <div className='col-md-12 slide-tabs d-flex horizontal-scroll-styled pb-2'>
            <Tabs
              value={activeTabIndex}
              variant='fullWidth'
              indicatorColor='primary'
              onChange={onTabChange}
              aria-label='tabs'
              textColor='primary'
              className='tabs'
            >
              {slidesList.map((tab, key) => (
                <Tab key={key} label={'Accordion ' + (key + 1)} />
              ))}
            </Tabs>
            <div className='ms-2'>
              <Button
                disabled={slidesList.length > 7}
                variant='outlined'
                size='large'
                color='secondary'
                onClick={(e) => onTabAdd(e)}
              >
                <Add />
              </Button>
            </div>
          </div>
          <div className='col-md-12 pe-5 mt-3'>
            <div className='col-md-12'>
              <TextField
                className='mt-2 col-md-12'
                variant='standard'
                label=''
                value={'Accordion ' + (activeTabIndex + 1)}
                InputProps={{
                  style: { color: '#828282' },
                  endAdornment: (
                    <InputAdornment position='end' className='pointer text-underlined'>
                      <span
                        onClick={(e) =>
                          handleRemoveClick(
                            e,
                            activeTabIndex,
                            slidesList,
                            setSlidesList,
                            setActveTabIndex,
                            setActveTabContent,
                          )
                        }
                      >
                        Remove
                      </span>
                    </InputAdornment>
                  ),
                }}
              />
              <CustomUiBuilderTextField
                label='H3 Title'
                required={true}
                className='col-md-12 mt-3'
                value={activeTabContent.titleH3}
                onChangeInput={(e) => handleTabData(e.target.value, activeTabContent, 'titleH3')}
                maxLength={100}
                isAdornment={true}
                endAdornment={true}
                error={hasError('titleH3')}
              />
              <CustomUiBuilderTextField
                label='Body2'
                required={true}
                className='col-md-12 mt-3'
                value={activeTabContent.body}
                onChangeInput={(e) => handleTabData(e.target.value, activeTabContent, 'body')}
                maxLength={9000}
                isAdornment={true}
                endAdornment={true}
                multiline={true}
                error={hasError('body')}
              />
              <div className='col-md-12 mt-4'>
                <ImagePicker
                  key={`accordion-icon-${activeTabIndex}`}
                  groupId={groupId}
                  title='Icon'
                  ratio={'1:1'}
                  height={24}
                  width={24}
                  matrix={'px'}
                  onImageSelect={(e) => handleTabData(e, activeTabContent, 'imgURL')}
                  imgURL={activeTabContent.imgURL}
                  error={hasError('imgURL')}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccordionWithIcon;
